import client from './api-client';

export const serviceBuscarEmisiones = async (query) => {
    try {
        const response = await client.getSelect(`consulta-emision-pagos?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceObtenerResumenPorCompania = async (query) => {
    try {
        const response = await client.getSelect(`consulta-emision-pagos?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceObtenerDetallePagos = async (query) => {
    try {
        const response = await client.getSelect(`consulta-emision-pagos?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceObtenerEstadoEmision = async (query) => {
    try {
        const response = await client.getSelect(`consulta-emision-pagos?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceVerCupon = async (query) => {
    try {
        const response = await client.getSelect(`consulta-emision-pagos?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}

export const serviceRegenerarInforme = async (body) => {
    try {
        const response = await client.postCia('consulta-emision-pagos', body);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}
